/*
  Nova Aura 2026-10-31 — buscador en móvil con el teclado abierto.
  1. La ventana del buscador ocupa solo la parte de pantalla que deja libre el teclado, así el campo,
     los resultados y «Ver todo» se pueden ver y tocar sin quedar debajo del teclado.
  2. Al deslizar los resultados con el dedo se cierra el teclado para dejar más sitio.
  No cambia cómo busca ni qué resultados salen.
*/
(function () {
  var vv = window.visualViewport;
  var mq = window.matchMedia('(max-width: 749px)');

  function dialog() { return document.querySelector('#search-modal dialog.search-modal__content'); }
  function input() { return document.querySelector('#search-modal input.search-input'); }

  function fit() {
    var d = dialog();
    if (!d) return;
    if (!vv || !mq.matches || !d.open) {
      d.style.removeProperty('--nova-vv-h');
      d.style.removeProperty('--nova-vv-top');
      return;
    }
    d.style.setProperty('--nova-vv-h', Math.round(vv.height) + 'px');
    d.style.setProperty('--nova-vv-top', Math.round(vv.offsetTop) + 'px');
  }

  if (vv) {
    vv.addEventListener('resize', fit);
    vv.addEventListener('scroll', fit);
  }
  if (mq.addEventListener) mq.addEventListener('change', fit);

  // Ajustar también al abrir y cerrar el buscador
  function watch() {
    var d = dialog();
    if (!d) return;
    new MutationObserver(fit).observe(d, { attributes: true, attributeFilter: ['open'] });
    var i = input();
    if (i) {
      i.setAttribute('enterkeyhint', 'search');
      i.addEventListener('focus', function () { setTimeout(fit, 50); setTimeout(fit, 350); });
    }

    // Deslizar los resultados cierra el teclado (un toque sin deslizar abre el producto como siempre)
    var startY = null;
    d.addEventListener('touchstart', function (e) {
      startY = e.target.closest('.predictive-search-form__content-wrapper') ? e.touches[0].clientY : null;
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      if (startY === null || !mq.matches) return;
      var i2 = input();
      if (i2 && document.activeElement === i2 && Math.abs(e.touches[0].clientY - startY) > 12) {
        i2.blur();
        startY = null;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
